module.exports = __webpack_public_path__ + "static/1.076e3ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./example/assets/1.jpg
// module id = 73
// module chunks = 0